import { render, staticRenderFns } from "./InternalNavAnchors.vue?vue&type=template&id=4130ca3c&"
import script from "./InternalNavAnchors.vue?vue&type=script&lang=js&"
export * from "./InternalNavAnchors.vue?vue&type=script&lang=js&"
import style0 from "./InternalNavAnchors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports